import { render, staticRenderFns } from "./ComponentDeduction.vue?vue&type=template&id=5d39fc56&scoped=true&"
import script from "./ComponentDeduction.vue?vue&type=script&lang=js&"
export * from "./ComponentDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d39fc56",
  null
  
)

export default component.exports